import {Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';


@Component({
  selector: 'app-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputNumberComponent),
      multi: true
    }
  ]

})
export class InputNumberComponent implements OnInit, OnDestroy, ControlValueAccessor {

  @Input() min = null;
  @Input() max = null;
  @Input() step = 1;
  @Input() required = false;
  @Input() disabled = false;
  @Output() inputModelChange = new EventEmitter<number>();
  value = 0;
  onChange: (_: any) => void = (_: any) => {};
  onTouched: () => void = () => {};


  constructor() { }
  writeValue(obj: any): void {
    this.value = obj;
    this.updateChanges();
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  updateChanges(): void {
    this.onChange(this.value);
  }

  sub(): void {
    if (this.min !== null && this.value > this.min) {
      this.value -= this.step;
    } else if (this.min === null) {
      this.value -= this.step;
    }
    this.updateChanges();
  }

  add(): void {
    if (this.max !== null && this.value < this.max) {
      this.value += this.step;
    } else if (this.max === null) {
      this.value += this.step;
    }
    this.updateChanges();
  }

  validate(): void {

  }

  blur(): void {
    if (this.value < this.min) {
      this.value = this.min;
    }
    if (this.value > this.max) {
      this.value = this.max;
    }
    this.updateChanges();
  }
}
